export default __webpack_public_path__ + "static/media/servico5.99fdb59d.jpg";